<template>
  <div class="home-template">
    <vue-headful title="Gunspring" />
    <div class="hero">
      <div class="container">
        <div class="row">
          <div class="col-xl-7 col-lg-6 col-md-6 col-sm-12">
            <p class="hero-title">The New<br>Standard in<br>Firearms Payments</p>
            <p
              class="hero-text"
            >FFLs and startups of all sizes use Gunspring's software and APIs to accept payments, fund their projects, and manage their businesses online.</p>
            <router-link
              class="request-demo-button hero-button"
              :to="{ name: 'userapps' }"
              v-if="accessToken!=null"
            >Sign Up</router-link>
            <router-link
              class="request-demo-button hero-button"
              :to="{ name: 'register' }"
              v-else
            >Sign Up</router-link>
          </div>
          <div class="col-xl-5 col-lg-6 col-md-6 col-sm-12">
            <img class="hero-img" :src="hero_img" />
          </div>
        </div>
      </div>
    </div>

    <div class="home-sections">
      <img class="home-accent-left" :src="accent_img" />
      <img class="home-accent-right" :src="accent_img" />
      <div class="container">
        <div class="home-section home-section-1">
          <div class="row">
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 order-md-last">
              <p class="home-section-feature-title home-section-feature-title-1">What is Gunspring</p>
              <p
                class="home-section-feature-text"
              >Gunspring offers a collection of software and integrations to accept payments, fight fraud and manage compliance, whether online or in-person. The Gunspring OE supports retailers, subscription businesses, ecommerce platforms, and startups.</p>
            </div>
            <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 order-md-first">
              <img class="laptop-img" :src="laptop_img" />
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="gs-customization">
      <div class="container">
        <p class="gs-customization-main-title">Customization with Gunspring</p>
        <div class="row">
          <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
            <div class="gs-customization-section gs-customization-section-1">
              <div class="row">
                <div class="col-xl-1 col-lg-1 col-md-1 col-sm-1 col-1">
                  <i class="fas fa-lg fa-fw fa-clipboard-check"></i>
                </div>
                <div class="col-xl-11 col-lg-11 col-md-11 col-sm-11 col-11">
                  <p class="gs-customization-title">FEDERAL AND MULTISTATE COMPLIANCE</p>
                  <p
                    class="gs-customization-text"
                  >Identify and decision non-compliant transactions, at the federal or state level, while improving the experience for legitimate buyers.</p>
                </div>
              </div>
            </div>
            <div class="gs-customization-section gs-customization-section-2">
              <div class="row">
                <div class="col-xl-1 col-lg-1 col-md-1 col-sm-1 col-1">
                  <i class="fas fa-lg fa-fw fa-shield-alt"></i>
                </div>
                <div class="col-xl-11 col-lg-11 col-md-11 col-sm-11 col-11">
                  <p class="gs-customization-title">ROBUST ANTI-FRAUD</p>
                  <p
                    class="gs-customization-text"
                  >Strengthen your anti-fraud and compliance with technical solutions that can be implemented in minutes.</p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
            <div class="gs-customization-section gs-customization-section-3">
              <div class="row">
                <div class="col-xl-1 col-lg-1 col-md-1 col-sm-1 col-1">
                  <i class="fas fa-lg fa-fw fa-shopping-cart"></i>
                </div>
                <div class="col-xl-11 col-lg-11 col-md-11 col-sm-11 col-11">
                  <p class="gs-customization-title">ECOMMERCE INTEGRATIONS</p>
                  <p
                    class="gs-customization-text"
                  >Improve conversions, reduce chargebacks and expand the kinds of payments you accept with industry-best analytics and security.</p>
                </div>
              </div>
            </div>
            <div class="gs-customization-section gs-customization-section-4">
              <div class="row">
                <div class="col-xl-1 col-lg-1 col-md-1 col-sm-1 col-1">
                  <i class="fas fa-lg fa-fw fa-hand-holding-usd"></i>
                </div>
                <div class="col-xl-11 col-lg-11 col-md-11 col-sm-11 col-11">
                  <p class="gs-customization-title">CUSTOM AND POINT OF SALE SOLUTIONS</p>
                  <p
                    class="gs-customization-text"
                  >Partner with Gunspring to expand and complement your sales strategies in difficult and changing regulatory environments.</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="ecommerce-integrations-section">
      <div class="container">
        <p class="ecommerce-integrations-section-title">Ecommerce Integrations</p>
        <div class="ecommerce-integrations-section-logos">
          <div class="row">
            <div class="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12 text-center">
              <img :src="logo_bigcommerce" />
            </div>
            <div class="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12 text-center">
              <img class="ecommerce-integration-section-logo-2" :src="logo_magento" />
            </div>
            <div class="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12 text-center">
              <img :src="logo_woocommerce" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Home",
  props: {
    msg: String
  },
  created(){
    this.accessToken=this.$store.state.accessToken;
  },
  data: () => ({
    hero_img: require("@/assets/images/hero.png"),
    accent_img: require("@/assets/images/accent.png"),
    laptop_img: require("@/assets/images/laptop-home-page.png"),
    logo_bigcommerce: require("@/assets/images/logo-bigcommerce.png"),
    logo_magento: require("@/assets/images/logo-magento.png"),
    logo_woocommerce: require("@/assets/images/logo-woocommerce.png"),
  })
};
</script>

<style scoped>
.home-accent-left {
  z-index: -1;
  position: absolute;
  bottom: 0;
  left: -114px;
  opacity: 0.5;
}
.home-accent-right {
  z-index: -1;
  position: absolute;
  top: -35px;
  right: -120px;
  opacity: 0.5;
}
.hero-img {
  width: 200%;
  position: relative;
  z-index: 2;
}
.laptop-img {
  width: 100%;
}

@media (max-width: 1199.98px) {
  .hero-title {
    padding-top: 180px;
    font-size: 49px;
  }
  .hero-img {
    width: 1025px;
  }
}

@media (max-width: 991.98px) {
  .hero-title {
    font-size: 37px;
    padding-top: 100px;
  }
  .hero-img {
    width: 695px;
  }
}

@media (max-width: 767.98px) {
  .hero-img {
    padding-top: 25px;
    width: 140%;
  }
  .home-section-1 {
    padding-top: 50px;
  }
  .hero-title {
    font-size: 36px;
    margin-top: 0;
    padding-top: 0;
  }
  .hero-text {
    font-size: 16px;
  }
  .hero {
    margin-top: 0;
  }
}
</style>
